import { createStyles, Theme } from '@material-ui/core';
import get from 'lodash/get';
import omit from 'lodash/omit';

import { styleFormIoComponent } from '#web-components/styles/form';
import { COMPONENT_CLASSES } from '../../constants';

const editGridSelector = `.${COMPONENT_CLASSES.editgrid}`;

export default (theme: Theme) => {
  const actionsWidth = theme.spacing(10);
  return createStyles({
    '@global': {
      [editGridSelector]: {
        ...get(styleFormIoComponent(COMPONENT_CLASSES.editgrid, theme), editGridSelector, {}),
        '& label.col-form-label, & span.col-form-label': {
          ...theme.typography.h6,
          color: theme.colors.textMainPrimary,
        },
      },
      ...omit(styleFormIoComponent(COMPONENT_CLASSES.editgrid, theme), editGridSelector),
    },
    root: {
      color: theme.colors.text.primary,
    },
    table: {
      marginBottom: '20px',
    },
    tableInner: {},
    cell: {
      height: theme.spacing(9) + 2,
      boxSizing: 'border-box',
    },
    row: {},
    selectedRow: {
      backgroundColor: theme.colors.pageElements.table.rowSelected,
      '& $actionsCell': {
        backgroundColor: theme.colors.pageElements.table.rowSelected,
      },
    },
    form: {
      paddingTop: theme.spacing(6),
      width: '100%',
      '& .formio-component-submit': {
        display: 'inline-block',
        marginRight: theme.spacing(3),
      },
      '& .formio-component-cancel': {
        display: 'inline-block',
      },
    },
    modal: {
      'max-width': theme.spacing(120),
      width: theme.spacing(120),
    },
    deleteModalButton: {
      marginRight: theme.spacing(3),
      display: 'inline-block',
    },
    deleteConfirmationRoot: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    deleteModalTitle: {
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(3),
    },
    actionsCell: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      border: 'none',
      position: 'absolute',
      right: 0,
      width: actionsWidth,
      background: theme.colors.layout.backgroundPrimary,
    },
    addButton: {},
    selectionCheckboxLabel: {
      padding: 0,
      margin: 0,
    },
    selectionCheckboxRoot: {
      padding: 0,
      margin: 0,
    },
    searchInput: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  });
};
